import React from 'react';
import useMetaTags from '../../hooks/useMetaTags';
import Services_we_offer from '../../component/Services_Component/Services_we_offer';
import { AssistanceSection, BenefitSection, BoostSection, CustomSection, FAQ, LargeData, ServicesSection, roleWriting } from '../../Data/All_Services_Data/seoContentWritingData';
import Custom_section from '../../component/Services_Component/Custom_services_section';
import Benefits_section from '../../component/Services_Component/Benefits_section';
import Boost_section from '../../component/Services_Component/Boost_section';
import Assistance_section from '../../component/Services_Component/Assistance_section';
import FAQ_section from '../../component/Services_Component/FAQ_section';
import Role_writing from '../../component/Services_Component/Role_writing';
import Handle_Largedata_section from "../../component/Services_Component/Handle_Largedata_section";

const SeoContentWriting = () => {
    useMetaTags({
      title:
        "SEO Content Writing Services | Best Content Writing Company Online",
      description:
        "SEO Content Writing Services by Warrgyizmorsch create high-quality, keyword-rich content to boost rankings, drive traffic, and engage your target audience effectively.",
      keywords:
        "seo content writing, seo writing, seo website content writer, seo copywriting, seo content services, seo content writing service, website content writing service, seo content writing agency, seo writing agency, seo copywriting agency, seo website writing",
    });
    return (
      <>
        <section
          className=""
          style={{
            backgroundImage: `url('assets/img/service/serviceD.jpg')`,
            backgroundPosition: "center",
            backgroundSize: "cover",
          }}
          id="service-sec"
        >
          <div className="round-container pt-5">
            <div className="container">
              <div className="title-area text-center">
                <span className="sub-title text-white">OUR SERVICES</span>
                <h2 className="sec-title text-white">
                  SEO Content Writing for Better Online Visibility
                </h2>
              </div>
            </div>
          </div>
        </section>
        <section className="space-extra-bottom">
          <div className="page-single">
            <div className="page-content">
              <style>{`
                    .header-section{
            display: flex;
            align-items: center;
            gap: 20px;
            margin-bottom: 30px;
        }
        .header-section img{
            height: 400px;
        }
        .header-section p{
            text-align: left;
        }

        @media only screen and (max-width: 990px) {
        .header-section{
            flex-direction: column;
        }
        .header-section img{
            height: 200px;
        }
            .header-section p{
            text-align: center;
        }
        }
                `}</style>
              {/* Intro part  */}
              <div
                className="header-section container"
                style={{ marginTop: "20px" }}
              >
                <img
                  src="assets/img/icon/seoContent.png"
                  loading="lazy"
                  alt="heading_image"
                />
                <div>
                  <p>
                    In the present digital age SEO content writing is a must for
                    better online visibility. We help businesses to put out
                    content that not only speaks to their audience but also to
                    search engine algorithms. By way of high quality and related
                    SEO techniques we can help you increase your rank in search
                    engines, bring in organic traffic, and which in turn
                    improves your overall online presence.
                  </p>
                </div>
              </div>

              {/* Warrgyizmorsch Content Writing Services  */}
              <Services_we_offer data={ServicesSection} />

              {/* Content Marketing Enhanced by SEO Research  */}
              <Handle_Largedata_section LargeData={LargeData} />

              {/* The Importance of SEO Content Writing for Business Growth */}
              <Custom_section data={CustomSection} />

              {/* Why Warrgyizmorsch Is Your Best Choice for SEO Content Marketing  */}
              <Benefits_section data={BenefitSection} />

              {/* What Are the Benefits of Content Writing?  */}
              <Assistance_section data={AssistanceSection} />

              {/* FAQ section  */}
              <FAQ_section data={FAQ} />
            </div>
          </div>
        </section>
        <div className="scroll-top">
          <svg
            className="progress-circle svg-content"
            width="100%"
            height="100%"
            viewBox="-1 -1 102 102"
          >
            <path
              d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98"
              style={{
                transition: "stroke-dashoffset 10ms linear 0s",
                strokeDasharray: "307.919, 307.919",
                strokeDashoffset: "307.919",
              }}
            ></path>
          </svg>
        </div>
      </>
    );
};

export default SeoContentWriting;